import $ from 'jquery'
import { lazyloadNewMedia } from './lazyload'
import { recalculateMasonry } from './masonry'
import { recalculateTextBlocks } from './block-text'

let $feed = null
let $loadMoreButton = null
let $loading = null

let page = 1
let limit = 30

export function init() {
  if (!$('[data-feed]').length) return

  const config = $('[data-feed]').data('feed')

  if (config.limit) {
    limit = config.limit
  }

  $feed = $('[data-feed]').find('.columns')
  $loading = $('[data-feed-loading]')
  $loadMoreButton = $('[data-feed-load-more]')

  $loadMoreButton.on('click', () => {
    page++
    loadMore()
  })

  // load first page of articles
  loadMore()
}

function loadMore() {
  $loading.show()
  $loadMoreButton.hide()
  $.ajax('https://www.hutchinsonbuilders.com.au/feed.json', {
    dataType: 'json',
    data: { page, limit },
    success: (data, status, xhr) => {
      // toggle load more button visibility
      $loading.hide()
      /*if (data.count < data.limit) $loadMoreButton.hide()
      else */ $loadMoreButton.show()

      // make all srcs/hrefs absolute
      const articlesText = (data.articles || '').replace(
        /(href|src)=['"]\/([^\/]|['"])/gi,
        '$1="https://www.hutchinsonbuilders.com.au/$2'
      )

      const $newArticles = $(articlesText)
      $newArticles.find('[data-scroll-reveal]').removeAttr('data-scroll-reveal')
      $newArticles.find('[data-src]').addClass('lazy')
      $feed.append($newArticles)

      lazyloadNewMedia()
      recalculateTextBlocks()
      recalculateMasonry()
      setTimeout(() => {
        recalculateMasonry()
      }, 120)
    },
  })
}
